import React, { useRef } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./portfolio_container.module.css";

import Navbar from "../components/portfolio_page/nav_bar/nav_bar";
import Greeting from "../components/portfolio_page/greeting/greeting";
import PortfolioList from "../components/portfolio_page/portfolio/portfolio_list/portfolio_list";
import Footer from "../components/portfolio_page/footer/footer";

import TechnicalCapabilities from "../components/portfolio_page/technical_capabilities/technical_capabilities";

const PortfolioContainer = () => {
  const [params, setParams] = useSearchParams();
  const selected = params.get('view') === 'capabilities' ? 'capabilities' : 'projects';
  const buttons = useRef({});
  const tabs = [{id: 'projects', label: '수행 프로젝트'}, {id: 'capabilities', label: '기술 역량'}];
  const select = id => { const next = new URLSearchParams(params); next.set('view', id); setParams(next, { replace: true }); };
  const onKeyDown = (event, index) => {
    let next;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') next = 1 - index;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = 1;
    else return;
    event.preventDefault();
    select(tabs[next].id);
    buttons.current[tabs[next].id]?.focus();
  };
  return (
    <>
      <Navbar />
      <Greeting />
      <main className={styles.main}>
        <div className={styles.tabs} role="tablist" aria-label="사업영역 보기">
          {tabs.map((tab, index) => <button key={tab.id} ref={node => { buttons.current[tab.id] = node; }} id={`tab-${tab.id}`} role="tab" type="button" aria-selected={selected === tab.id} aria-controls={`panel-${tab.id}`} tabIndex={selected === tab.id ? 0 : -1} onClick={() => select(tab.id)} onKeyDown={event => onKeyDown(event, index)}>{tab.label}</button>)}
        </div>
        <div id="panel-projects" role="tabpanel" aria-labelledby="tab-projects" hidden={selected !== 'projects'} tabIndex={0}><PortfolioList /></div>
        <div id="panel-capabilities" role="tabpanel" aria-labelledby="tab-capabilities" hidden={selected !== 'capabilities'} tabIndex={0}><TechnicalCapabilities /></div>
      </main>
      <Footer />
    </>
  )
}

export default PortfolioContainer;